/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateRoleInput
 */
export interface CreateRoleInput {
    /**
     * 
     * @type {string}
     * @memberof CreateRoleInput
     */
    name?: string;
}

/**
 * Check if a given object implements the CreateRoleInput interface.
 */
export function instanceOfCreateRoleInput(value: object): value is CreateRoleInput {
    return true;
}

export function CreateRoleInputFromJSON(json: any): CreateRoleInput {
    return CreateRoleInputFromJSONTyped(json, false);
}

export function CreateRoleInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRoleInput {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function CreateRoleInputToJSON(json: any): CreateRoleInput {
    return CreateRoleInputToJSONTyped(json, false);
}

export function CreateRoleInputToJSONTyped(value?: CreateRoleInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

